module.exports = __webpack_public_path__ + "dfca31aa503ac9edd7bcc5018aefecad.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/developpement/commerce_electronique.jpg
// module id = 160
// module chunks = 0